import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./mockup.css";
import { NewsletterBar } from "./NewsletterBar";
import { MockHeader } from "./Header";
import { MockFooter } from "./Footer";
import { Popup } from "./Popup";

export const Shell = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(
        () => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }),
        200
      );
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="mockup-page">
      <NewsletterBar />
      <MockHeader />
      <main id="main">{children}</main>
      <MockFooter />
      <Popup />
    </div>
  );
};
